import type { SVGProps } from 'react'
const SvgYoutubeLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.58 16.81a2.5 2.5 0 0 1-1.77 1.77C18.25 19 12 19 12 19s-6.25 0-7.81-.42a2.5 2.5 0 0 1-1.77-1.77C2 15.25 2 12 2 12s0-3.25.42-4.81a2.5 2.5 0 0 1 1.77-1.77C5.75 5 12 5 12 5s6.25 0 7.81.42a2.5 2.5 0 0 1 1.77 1.77C22 8.75 22 12 22 12s0 3.25-.42 4.81M10 9v6l5.2-3z"
    />
  </svg>
)
export default SvgYoutubeLogo
